import UserAccessSettingsStatus from './UserAccessSettingsStatus';

export default UserAccessSettingsStatus;
